/** Do not edit directly **/
/**
* This function require the following tokens:
*
*   // DISABLED STATE
*   sy-{$component}-background-color-disabled-{$color}
*   sy-{$component}-color-disabled-{$color}
*   sy-{$component}-border-color-disabled-{$color}
*
*   // HOVER and FOCUS STATE
*   sy-{$component}-background-color-hover-{$color}
*   sy-{$component}-border-color-hover-{$color}
*
*   // ACTIVE STATE
*   sy-{$component}-background-color-active-{$color}
*   sy-{$component}-border-color-active-{$color}
*
*   // FOCUS VISIBLE STATE
*   sy-{$component}-border-color-focus-visible
*/
/**
* DEPRECATED
*/
/**
* DEPRECATED
*/
/**
* DEPRECATED
*/
/** Do not edit directly **/
/**
 * @prop --sy-input-color: Input color.
 * @prop --sy-input-color-disabled: Input color disabled.
 * @prop --sy-input-color-error: Input color error.
 * @prop --sy-input-color-label-focus: Input color label focus.
 * @prop --sy-input-color-focus: Input color focus.
 * @prop --sy-input-border-radius: Input border radius.
 * @prop --sy-input-border-color: Input border color.
 * @prop --sy-input-border-color-focus: Input border color focus.
 * @prop --sy-input-border-color-error: Input border color error.
 * @prop --sy-input-border-color-hover: Input border color hover.
 * @prop --sy-input-icon-size: Input icon size.
 * @prop --sy-input-icon-color: Input icon color.
 * @prop --sy-input-clear-icon-size: Input clear icon size.
 * @prop --sy-input-clear-icon-stroke-width: Input clear icon stroke width.
 * @prop --sy-input-clear-icon-margin-left: Input clear icon margin left.
 * @prop --sy-input-error-margin-top: Form error margin top.
 * @prop --sy-input-error-font-size: Input error font size.
 * @prop --sy-input-error-text-decoration: Input error text decoration.
 * @prop --sy-input-error-font-family: Input error font family.
 * @prop --sy-input-error-font-weight: Input error font weight.
 * @prop --sy-input-error-font-style: Input error font style.
 * @prop --sy-input-error-font-stretch: Input error font stretch.
 * @prop --sy-input-error-letter-spacing: Input error letter spacing.
 * @prop --sy-input-error-line-height: Input error line height.
 * @prop --sy-input-font-size: Input font size.
 * @prop --sy-input-text-decoration: Input text decoration.
 * @prop --sy-input-font-family: Input font family.
 * @prop --sy-input-font-weight: Input font weight.
 * @prop --sy-input-font-style: Input font style.
 * @prop --sy-input-font-stretch: Input font stretch.
 * @prop --sy-input-letter-spacing: Input letter spacing.
 * @prop --sy-input-line-height: Input line height.
 * @prop --sy-input-floating-label-font-size: Input floating label font size.
 * @prop --sy-input-floating-label-text-decoration: Input floating label text decoration.
 * @prop --sy-input-floating-label-font-family: Input floating label font family.
 * @prop --sy-input-floating-label-font-weight: Input floating label font weight.
 * @prop --sy-input-floating-label-font-style: Input floating label font style.
 * @prop --sy-input-floating-label-font-stretch: Input floating label font stretch.
 * @prop --sy-input-floating-label-letter-spacing: Input floating label letter spacing.
 * @prop --sy-input-floating-label-line-height: Input floating label line height.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

input,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

textarea {
  resize: vertical;
}

:host {
  display: block;
  width: 100%;
  --sy-icon-size: var(--sy-input-icon-size, 16px);
  outline: 0;
}

:host([disabled]) .sy-form-field {
  border-bottom-color: var(--sy-input-color-disabled, var(--sy-disabled));
  box-shadow: none;
}
:host([disabled]) .sy-form-label {
  color: var(--sy-input-color-disabled, var(--sy-disabled)) !important;
}
:host([disabled]) sy-icon {
  --sy-icon-color: var(--sy-input-color-disabled, var(--sy-disabled));
}
:host([disabled]) .sy-form-control {
  color: var(--sy-input-color-disabled, var(--sy-disabled));
  pointer-events: none;
}

:host([readonly]:not([disabled])) .sy-form-field {
  border-bottom-color: transparent;
  box-shadow: none;
}
:host([readonly]:not([disabled])) .sy-form-label {
  color: var(--sy-input-color, var(--sy-foreground-medium-emphasis));
}
:host([readonly]:not([disabled])) .sy-form-label.sy-has-value {
  color: var(--sy-input-color-focus, var(--sy-foreground-high-emphasis));
}
:host([readonly]:not([disabled])) .sy-form-control {
  pointer-events: none;
}

:host([error]:not([disabled], [readonly])) .sy-form-field {
  border-bottom-color: var(--sy-input-border-color-error, var(--sy-error));
  box-shadow: none;
}
:host([error]:not([disabled], [readonly])) .sy-form-label {
  color: var(--sy-input-color-error, var(--sy-error));
}
:host([error]:not([disabled], [readonly])) .sy-form-control {
  caret-color: var(--sy-input-color-error, var(--sy-error));
}
:host([error]:not([disabled], [readonly])) sy-icon {
  --sy-icon-color: var(--sy-input-color-error, var(--sy-error));
}

:host(:focus[error]:not([disabled], [readonly])) .sy-form-field,
:host(:hover[error]:not([disabled], [readonly])) .sy-form-field {
  box-shadow: inset 0 -1px 0 var(--sy-input-border-color-error, var(--sy-error));
}

:host(:not([disabled], [readonly], [error])) .sy-form-field {
  border-bottom: 1px solid var(--sy-input-border-color, var(--sy-border));
}
:host(:not([disabled], [readonly], [error])) .sy-form-label {
  color: var(--sy-input-color, var(--sy-foreground-medium-emphasis));
}
:host(:not([disabled], [readonly], [error])) .sy-form-label.sy-has-value {
  color: var(--sy-input-color-focus, var(--sy-foreground-high-emphasis));
}
:host(:not([disabled], [readonly], [error])) sy-icon {
  --sy-icon-color: var(--sy-input-icon-color, var(--sy-foreground-medium-emphasis));
}

:host(:focus:not([disabled], [readonly], [error])) .sy-form-field {
  border-bottom-color: var(--sy-input-border-color-focus, var(--sy-accent));
  box-shadow: inset 0 -1px 0 var(--sy-input-border-color-focus, var(--sy-accent));
}
:host(:focus:not([disabled], [readonly], [error])) .sy-form-label {
  color: var(--sy-input-color-label-focus, var(--sy-accent));
}
:host(:focus:not([disabled], [readonly], [error])) .sy-form-control {
  caret-color: var(--sy-input-color-label-focus, var(--sy-accent));
}
:host(:focus:not([disabled], [readonly], [error])) sy-icon {
  --sy-icon-color: var(--sy-input-color-label-focus, var(--sy-accent));
}

:host(:hover:not([disabled], [readonly], [error], :focus)) .sy-form-field {
  border-color: var(--sy-input-border-color-hover, var(--sy-foreground-medium-emphasis));
}

.sy-form-field {
  position: relative;
  display: block;
  align-items: center;
  border-bottom: 1px solid var(--sy-input-border-color, var(--sy-border));
}
:host([label]) .sy-form-field {
  padding-top: 1.25em;
}

.sy-form-label {
  position: absolute;
  top: 1.75em;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  transition: all 0.2s;
}
.sy-form-control ~ .sy-input-icon-left ~ .sy-form-label {
  left: calc(var(--sy-input-icon-size, 16px) + .5rem);
}

.sy-form-control {
  font-size: var(--sy-input-font-size, var(--sy-content-regular-body-font-size));
  text-decoration: var(--sy-input-text-decoration, var(--sy-content-regular-body-text-decoration));
  font-family: var(--sy-input-font-family, var(--sy-content-regular-body-font-family));
  font-weight: var(--sy-input-font-weight, var(--sy-content-regular-body-font-weight));
  font-style: var(--sy-input-font-style, var(--sy-content-regular-body-font-style));
  font-stretch: var(--sy-input-font-stretch, var(--sy-content-regular-body-font-stretch));
  letter-spacing: var(--sy-input-letter-spacing, var(--sy-content-regular-body-letter-spacing));
  line-height: var(--sy-input-line-height, var(--sy-content-regular-body-line-height));
  display: block;
  width: 100%;
  min-height: 1.5em;
  padding: 0;
  margin: 8px 0;
  color: var(--sy-input-color, var(--sy-foreground-medium-emphasis));
  background-color: transparent;
  border: 0;
  outline: 0;
  transition: all 0.2s;
  appearance: none;
}
.sy-form-control::placeholder {
  color: var(--sy-input-color-disabled, var(--sy-disabled));
}
:host([label]) .sy-form-control::placeholder {
  opacity: 0;
  transition: all 0.2s;
}
:host(:focus:not([readonly])) .sy-form-control ~ .sy-form-label, .sy-form-control[type=file] ~ .sy-form-label,
.sy-form-control ~ .sy-form-label.sy-has-value {
  top: 0;
  left: 0;
  font-size: var(--sy-input-floating-label-font-size, var(--sy-content-regular-small-font-size));
  text-decoration: var(--sy-input-floating-label-text-decoration, var(--sy-content-regular-small-text-decoration));
  font-family: var(--sy-input-floating-label-font-family, var(--sy-content-regular-small-font-family));
  font-weight: var(--sy-input-floating-label-font-weight, var(--sy-content-regular-small-font-weight));
  font-style: var(--sy-input-floating-label-font-style, var(--sy-content-regular-small-font-style));
  font-stretch: var(--sy-input-floating-label-font-stretch, var(--sy-content-regular-small-font-stretch));
  letter-spacing: var(--sy-input-floating-label-letter-spacing, var(--sy-content-regular-small-letter-spacing));
  line-height: var(--sy-input-floating-label-line-height, var(--sy-content-regular-small-line-height));
}
:host(:focus:not([readonly])) .sy-form-control {
  color: var(--sy-input-color-focus, var(--sy-foreground-high-emphasis));
}
:host(:focus:not([readonly])) .sy-form-control::placeholder {
  opacity: 1 !important;
}

.sy-form-error {
  margin-top: var(--sy-input-error-margin-top, var(--sy-spacer-2));
  font-size: var(--sy-input-error-font-size, var(--sy-content-regular-small-font-size));
  text-decoration: var(--sy-input-error-text-decoration, var(--sy-content-regular-small-text-decoration));
  font-family: var(--sy-input-error-font-family, var(--sy-content-regular-small-font-family));
  font-weight: var(--sy-input-error-font-weight, var(--sy-content-regular-small-font-weight));
  font-style: var(--sy-input-error-font-style, var(--sy-content-regular-small-font-style));
  font-stretch: var(--sy-input-error-font-stretch, var(--sy-content-regular-small-font-stretch));
  letter-spacing: var(--sy-input-error-letter-spacing, var(--sy-content-regular-small-letter-spacing));
  line-height: var(--sy-input-error-line-height, var(--sy-content-regular-small-line-height));
  color: var(--sy-input-color-error, var(--sy-error));
}

.sy-form-field {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.sy-form-control {
  order: 1;
}
.sy-form-control[type=file] {
  padding: 0.5rem 0;
  margin: 0;
  overflow: hidden;
  color: var(--sy-input-color, var(--sy-foreground-medium-emphasis));
}
.sy-form-control[type=file]:disabled {
  color: var(--sy-input-color-disabled, var(--sy-disabled));
}
.sy-form-control[type=file]:disabled::file-selector-button {
  background-color: var(--sy-input-color-disabled, var(--sy-disabled));
  border-color: var(--sy-input-color-disabled, var(--sy-disabled));
}
.sy-form-control[type=file]:not(:disabled) {
  pointer-events: all;
  cursor: pointer;
}
.sy-form-control::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.5rem 0.5rem -0.5rem 0;
  font-size: var(--sy-input-font-size, var(--sy-content-regular-body-font-size));
  pointer-events: none;
  background-color: transparent;
  border: 1px solid var(--sy-input-border-color, var(--sy-border));
  border-radius: var(--sy-input-border-radius, var(--sy-border-radius));
}

.sy-form-field-container {
  position: relative;
  display: block;
  width: 100%;
}

.sy-input-icon-left {
  order: 0;
  margin-right: 0.5rem;
}

.sy-input-view-icon {
  order: 2;
}

.sy-input-clear-icon {
  order: 3;
  --sy-dismiss-icon-size: var(--sy-input-clear-icon-size, 10px);
  --sy-dismiss-icon-stroke-width: var(--sy-input-clear-icon-stroke-width, 1.5px);
  margin-left: var(--sy-input-clear-icon-margin-left, var(--sy-spacer-2));
}

.sy-input-icon-right {
  order: 4;
  margin-left: 0.5rem;
}